import {
  Country,
  getCountries,
  getCountryCallingCode,
  parsePhoneNumber,
  Value,
} from "react-phone-number-input";
import en from "react-phone-number-input/locale/en.json";
import { PhoneInputValue } from "./types";

const callingCodeToCountry = new Map<string, Country>(
  getCountries().map((c) => [getCountryCallingCode(c), c])
);

export const getCountryFromValue = (
  value: Value | undefined,
  defaultCountry: Country
): Country => {
  if (!value) return defaultCountry;

  try {
    const parsed = parsePhoneNumber(value);

    if (parsed?.country) {
      return parsed.country as Country;
    }

    if (parsed?.countryCallingCode) {
      const match = callingCodeToCountry.get(parsed.countryCallingCode);
      if (match) {
        return match;
      }
    }

    return defaultCountry;
  } catch {
    return defaultCountry;
  }
};

export const getCountryName = (country: Country) => {
  return en[country];
};

export const parseToPhoneInputValue = (
  fullNumber: Value | undefined,
  country: Country
): PhoneInputValue | undefined => {
  if (!fullNumber) return undefined;

  const prefix = `+${getCountryCallingCode(country)}`;
  const number = fullNumber.startsWith(prefix)
    ? fullNumber.slice(prefix.length)
    : fullNumber.replace(/^\+\d+/, ""); // fallback: strip any dial code

  return { prefix, number };
};
